/* Craftsmanship steps: mobile swipe slider (85% peeking cards), dots, optional autoplay. One instance per section. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  document.querySelectorAll('.craftsmanship-steps-section[data-mobile-slider="true"]').forEach(function (section) {
    var slider = section.querySelector('.steps-slider'); var track = section.querySelector('.steps-track');
    var cards = track ? track.querySelectorAll('.step-card') : []; var dots = section.querySelectorAll('.slider-dots .dot');
    if (!slider || cards.length < 2) return;
    var i = 0, timer = null, x0 = 0;
    var autoplay = section.dataset.autoplay === 'true'; var speed = (parseFloat(section.dataset.autoplaySpeed) || 0) * 1000;
    function render() {
      if (!mq.matches) { track.style.transform = ''; return; }
      var gap = parseFloat(getComputedStyle(track).gap) || 0; var offset = i * (cards[0].offsetWidth + gap);
      var max = track.scrollWidth - slider.offsetWidth; if (max > 0 && offset > max) offset = max;
      track.style.transform = 'translateX(-' + offset + 'px)';
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    function go(n) { i = Math.max(0, Math.min(n, cards.length - 1)); render(); }
    function next() { if (i < cards.length - 1) go(i + 1); else if (autoplay) go(0); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (autoplay && speed > 0 && mq.matches) timer = setInterval(next, speed); }
    dots.forEach(function (d) { d.addEventListener('click', function () { stop(); go(+d.dataset.index); }); });
    slider.addEventListener('touchstart', function (e) { if (!mq.matches) return; x0 = e.changedTouches[0].screenX; stop(); }, { passive: true });
    slider.addEventListener('touchend', function (e) { if (!mq.matches) return; var dx = x0 - e.changedTouches[0].screenX; if (Math.abs(dx) > 50) { dx > 0 ? next() : go(i - 1); } }, { passive: true });
    slider.addEventListener('mouseenter', stop); slider.addEventListener('mouseleave', start);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { if (!mq.matches) { stop(); i = 0; } render(); start(); }, 100); }, { passive: true });
    render(); start();
  });
})();
